import { FC, MouseEventHandler, ReactElement } from 'react';

import { MiniatureMessageLayout } from 'APP/main/ChatView/components/MiniatureMessageLayout/MiniatureMessageLayout';
import type { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

interface IStickerProps {
  titleClassName?: string;
  textClassName?: string;
  iconClassName?: string;
  message: ChatMessage;
  title: string | ReactElement;
  onClick: MouseEventHandler;
  preventInteraction?: boolean;
}

export const MiniatureMessageSticker: FC<IStickerProps> = (props) => {
  const {
    titleClassName,
    textClassName,
    iconClassName,
    message,
    title,
    onClick,
    preventInteraction,
  } = props;

  return (
    <MiniatureMessageLayout
      titleClassName={titleClassName}
      textClassName={textClassName}
      iconClassName={iconClassName}
      imageUrl={message.payload.url}
      graphicSize={message.payload.graphicSize}
      title={title}
      text={message.payload.typeDescription}
      messageId={message.id}
      onClick={onClick}
      preventInteraction={preventInteraction}
    />
  );
};
